import { Route } from "react-router-dom";
import AuthRoute from "./AuthRoute";
import PermissionRoute from "./PermissionRoute";

/* Layouts */
import MainLayout from "../layout/MainLayout";
import HRLayout from "../layout/Hr/HrLayout";
import MemberLayout from "../layout/Member/MemberLayout";

/* Dashboards */
import AdminDashboard from "../pages/AdminDashboard";
import CalendarView from "../pages/Calendar/CalendarView";
import ShiftPlanner from "../pages/Shifts/ShiftPlanner";
import LeaveView from "../pages/Leaves/LeaveView";
import Attendance from "../pages/Attendance/Attendance";
import HRDashboard from "../pages/HRDashboard";
import MemberDashboard from "../pages/MemberDashboard";
import OrganisationChart from "../pages/OrganisationChart/OrganisationChart";
import StarOfMonthManagement from "../pages/StarOfMonth/StarOfMonthManagement";
import NewsletterList from "../pages/Newsletter/NewsletterList";
import NewsletterEditor from "../pages/Newsletter/NewsletterEditor";
import NotesPage from "../pages/Notes/NotesPage";
import NotificationsPage from "../features/notifications/NotificationsPage";
import SignOffDocumentsPage from "../pages/SignOff/SignOffDocumentsPage";
import ProfileGeneratorList from "../pages/ProfileGenerator/ProfileGeneratorList";
import ProfileGeneratorEditor from "../pages/ProfileGenerator/ProfileGeneratorEditor";

/* Pages */
import TeamManagement from "../pages/Team/TeamManagement";
import EmployeeProfilePage from "../pages/Team/EmployeeProfilePage";
import EmployeeEditPage from "../pages/Team/EmployeeEditPage";
import UsersManagement from "../pages/UsersManagement";
import SignatureManagement from "../pages/Signature/SignaturesManagement";
import ViewSignature from "../pages/Signature/ViewSignature";
import EditSignature from "../pages/Signature/EditSignature";
import AddSignature from "../pages/Signature/AddSignature";
import GenerateLetter from "../pages/GenerateLetter/GenerateLetter";
import Onboarding from "../pages/Onboarding";
import OnboardingWizard from "../pages/Onboarding/OnboardingWizard";
import AcceptInvite from "../pages/AcceptInvite";
import CreateNew from "../pages/GenerateLetter/CreateNew";
import LetterView from "../pages/GenerateLetter/LetterView";

/* Settings */
import SettingsRoutes from "./SettingsRoutes";

/* Workspace */
import WorkspaceRoutes from "./WorkspaceRoutes";

export const PrivateRoutes = (
  <>
    <Route element={<AuthRoute />}>
      {/* ================= ADMIN LAYOUT ================= */}
      <Route path="/admin" element={<MainLayout />}>
        <Route
          index
          element={
            <PermissionRoute permission="view_dashboard">
              <AdminDashboard />
            </PermissionRoute>
          }
        />
        <Route
          path="dashboard"
          element={
            <PermissionRoute permission="view_dashboard">
              <AdminDashboard />
            </PermissionRoute>
          }
        />

        <Route
          path="users"
          element={
            <PermissionRoute permission="manage_roles_permissions">
              <UsersManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="teams"
          element={
            <PermissionRoute permission="view_employees">
              <TeamManagement />
            </PermissionRoute>
          }
        />
        <Route
          path="teams/:id"
          element={
            <PermissionRoute permission="view_employees">
              <EmployeeProfilePage />
            </PermissionRoute>
          }
        />
        <Route
          path="teams/:id/edit"
          element={
            <PermissionRoute permission="view_employees">
              <EmployeeEditPage />
            </PermissionRoute>
          }
        />

        <Route
          path="signature"
          element={
            <PermissionRoute permission="view_signatures">
              <SignatureManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="generateletter"
          element={
            <PermissionRoute permission="generate_letters">
              <GenerateLetter />
            </PermissionRoute>
          }
        />

        <Route
          path="signature/signature/:id"
          element={
            <PermissionRoute permission="view_signatures">
              <ViewSignature />
            </PermissionRoute>
          }
        />

        <Route
          path="signature/add"
          element={
            <PermissionRoute permission="view_signatures">
              <AddSignature />
            </PermissionRoute>
          }
        />

        <Route
          path="signature/:id/edit"
          element={
            <PermissionRoute permission="view_signatures">
              <EditSignature />
            </PermissionRoute>
          }
        />

        <Route
          path="attendance"
          element={
            <PermissionRoute permission="view_calendar">
              <Attendance />
            </PermissionRoute>
          }
        />

        <Route
          path="calendar"
          element={
            <PermissionRoute permission="view_calendar">
              <CalendarView />
            </PermissionRoute>
          }
        />

        <Route
          path="leaves"
          element={
            <PermissionRoute permission="view_leaves">
              <LeaveView />
            </PermissionRoute>
          }
        />

        <Route
          path="shifts"
          element={
            <PermissionRoute permission="view_shifts">
              <ShiftPlanner />
            </PermissionRoute>
          }
        />

        <Route
          path="OrgChart"
          element={
            <PermissionRoute permission="view_org_chart">
              <OrganisationChart />
            </PermissionRoute>
          }
        />

        <Route
          path="generateletter/create"
          element={
            <PermissionRoute permission="generate_letters">
              <CreateNew />
            </PermissionRoute>
          }
        />
        <Route
          path="generateletter/:id"
          element={
            <PermissionRoute permission="generate_letters">
              <LetterView />
            </PermissionRoute>
          }
        />
        <Route
          path="star-of-the-month"
          element={
            <PermissionRoute permission="manage_star_of_month">
              <StarOfMonthManagement />
            </PermissionRoute>
          }
        />
        <Route
          path="newsletters"
          element={
            <PermissionRoute permission="manage_newsletter">
              <NewsletterList />
            </PermissionRoute>
          }
        />
        <Route
          path="newsletters/:id"
          element={
            <PermissionRoute permission="manage_newsletter">
              <NewsletterEditor />
            </PermissionRoute>
          }
        />
        <Route
          path="settings/*"
          element={
            <PermissionRoute permission="view_settings">
              <SettingsRoutes />
            </PermissionRoute>
          }
        />
        <Route
          path="workspace/*"
          element={
            <PermissionRoute permission="view_workspace">
              <WorkspaceRoutes />
            </PermissionRoute>
          }
        />
        <Route
          path="notes"
          element={
            <PermissionRoute permission="view_notes">
              <NotesPage />
            </PermissionRoute>
          }
        />
        <Route
          path="signoff-documents"
          element={
            <PermissionRoute permission="view_signoff">
              <SignOffDocumentsPage />
            </PermissionRoute>
          }
        />
        <Route
          path="profile-generator"
          element={
            <PermissionRoute permission="view_profile_generator">
              <ProfileGeneratorList />
            </PermissionRoute>
          }
        />
        <Route
          path="profile-generator/:id"
          element={
            <PermissionRoute permission="view_profile_generator">
              <ProfileGeneratorEditor />
            </PermissionRoute>
          }
        />
        <Route
          path="notifications"
          element={
            <PermissionRoute permission="view_notifications">
              <NotificationsPage />
            </PermissionRoute>
          }
        />
      </Route>

      {/* ================= HR LAYOUT ================= */}
      <Route path="/hr" element={<HRLayout />}>
        <Route
          index
          element={
            <PermissionRoute permission="view_dashboard">
              <HRDashboard />
            </PermissionRoute>
          }
        />
        <Route
          path="dashboard"
          element={
            <PermissionRoute permission="view_dashboard">
              <HRDashboard />
            </PermissionRoute>
          }
        />
        <Route
          path="calendar"
          element={
            <PermissionRoute permission="view_calendar">
              <CalendarView />
            </PermissionRoute>
          }
        />
        <Route
          path="leaves"
          element={
            <PermissionRoute permission="view_leaves">
              <LeaveView />
            </PermissionRoute>
          }
        />
        <Route
          path="attendance"
          element={
            <PermissionRoute permission="view_attendance">
              <Attendance />
            </PermissionRoute>
          }
        />
        <Route
          path="users"
          element={
            <PermissionRoute permission="manage_roles_permissions">
              <UsersManagement />
            </PermissionRoute>
          }
        />
        <Route
          path="teams"
          element={
            <PermissionRoute permission="view_employees">
              <TeamManagement />
            </PermissionRoute>
          }
        />
        <Route
          path="teams/:id"
          element={
            <PermissionRoute permission="view_employees">
              <EmployeeProfilePage />
            </PermissionRoute>
          }
        />
        <Route
          path="teams/:id/edit"
          element={
            <PermissionRoute permission="view_employees">
              <EmployeeEditPage />
            </PermissionRoute>
          }
        />
        <Route
          path="OrgChart"
          element={
            <PermissionRoute permission="view_org_chart">
              <OrganisationChart />
            </PermissionRoute>
          }
        />
        <Route
          path="shifts"
          element={
            <PermissionRoute permission="view_shifts">
              <ShiftPlanner />
            </PermissionRoute>
          }
        />
        <Route
          path="star-of-the-month"
          element={
            <PermissionRoute permission="manage_star_of_month">
              <StarOfMonthManagement />
            </PermissionRoute>
          }
        />
        <Route
          path="settings/*"
          element={
            <PermissionRoute permission="view_settings">
              <SettingsRoutes />
            </PermissionRoute>
          }
        />
        <Route
          path="workspace/*"
          element={
            <PermissionRoute permission="view_workspace">
              <WorkspaceRoutes />
            </PermissionRoute>
          }
        />
        <Route
          path="notes"
          element={
            <PermissionRoute permission="view_notes">
              <NotesPage />
            </PermissionRoute>
          }
        />
        <Route
          path="signoff-documents"
          element={
            <PermissionRoute permission="view_signoff">
              <SignOffDocumentsPage />
            </PermissionRoute>
          }
        />
        <Route
          path="profile-generator"
          element={
            <PermissionRoute permission="view_profile_generator">
              <ProfileGeneratorList />
            </PermissionRoute>
          }
        />
        <Route
          path="profile-generator/:id"
          element={
            <PermissionRoute permission="view_profile_generator">
              <ProfileGeneratorEditor />
            </PermissionRoute>
          }
        />
        <Route
          path="notifications"
          element={
            <PermissionRoute permission="view_notifications">
              <NotificationsPage />
            </PermissionRoute>
          }
        />

        {/* HR Letters — same gates as the admin section */}
        <Route
          path="signature"
          element={
            <PermissionRoute permission="view_signatures">
              <SignatureManagement />
            </PermissionRoute>
          }
        />
        <Route
          path="signature/signature/:id"
          element={
            <PermissionRoute permission="view_signatures">
              <ViewSignature />
            </PermissionRoute>
          }
        />
        <Route
          path="signature/add"
          element={
            <PermissionRoute permission="view_signatures">
              <AddSignature />
            </PermissionRoute>
          }
        />
        <Route
          path="signature/:id/edit"
          element={
            <PermissionRoute permission="view_signatures">
              <EditSignature />
            </PermissionRoute>
          }
        />
        <Route
          path="generateletter"
          element={
            <PermissionRoute permission="generate_letters">
              <GenerateLetter />
            </PermissionRoute>
          }
        />
        <Route
          path="generateletter/create"
          element={
            <PermissionRoute permission="generate_letters">
              <CreateNew />
            </PermissionRoute>
          }
        />
        <Route
          path="generateletter/:id"
          element={
            <PermissionRoute permission="generate_letters">
              <LetterView />
            </PermissionRoute>
          }
        />
      </Route>

      {/* ================= MEMBER LAYOUT ================= */}
      <Route path="/member" element={<MemberLayout />}>
        <Route
          index
          element={
            <PermissionRoute permission="view_dashboard">
              <MemberDashboard />
            </PermissionRoute>
          }
        />
        <Route
          path="dashboard"
          element={
            <PermissionRoute permission="view_dashboard">
              <MemberDashboard />
            </PermissionRoute>
          }
        />
        <Route
          path="calendar"
          element={
            <PermissionRoute permission="view_calendar">
              <CalendarView />
            </PermissionRoute>
          }
        />

        <Route
          path="leaves"
          element={
            <PermissionRoute permission="apply_leave">
              <LeaveView />
            </PermissionRoute>
          }
        />
        <Route
          path="attendance"
          element={
            <PermissionRoute permission="view_calendar">
              <Attendance />
            </PermissionRoute>
          }
        />
        <Route
          path="teams"
          element={
            <PermissionRoute permission="view_employees">
              <TeamManagement />
            </PermissionRoute>
          }
        />
        {/* Member gets a read-only profile view for everyone, plus a
            self-edit route (EmployeeEditPage guards that :id is their own). */}
        <Route
          path="teams/:id"
          element={
            <PermissionRoute permission="view_employees">
              <EmployeeProfilePage />
            </PermissionRoute>
          }
        />
        <Route
          path="teams/:id/edit"
          element={
            <PermissionRoute permission="view_employees">
              <EmployeeEditPage />
            </PermissionRoute>
          }
        />
        <Route
          path="OrgChart"
          element={
            <PermissionRoute permission="view_org_chart">
              <OrganisationChart readOnly />
            </PermissionRoute>
          }
        />
        <Route
          path="shifts"
          element={
            <PermissionRoute permission="view_shifts">
              <ShiftPlanner readOnly />
            </PermissionRoute>
          }
        />
        <Route
          path="settings/*"
          element={
            <PermissionRoute permission="view_settings">
              <SettingsRoutes />
            </PermissionRoute>
          }
        />
        <Route
          path="workspace/*"
          element={
            <PermissionRoute permission="view_workspace">
              <WorkspaceRoutes />
            </PermissionRoute>
          }
        />
        <Route
          path="notes"
          element={
            <PermissionRoute permission="view_notes">
              <NotesPage />
            </PermissionRoute>
          }
        />
        <Route
          path="signoff-documents"
          element={
            <PermissionRoute permission="view_signoff">
              <SignOffDocumentsPage />
            </PermissionRoute>
          }
        />
        <Route
          path="profile-generator"
          element={
            <PermissionRoute permission="view_profile_generator">
              <ProfileGeneratorList />
            </PermissionRoute>
          }
        />
        <Route
          path="profile-generator/:id"
          element={
            <PermissionRoute permission="view_profile_generator">
              <ProfileGeneratorEditor />
            </PermissionRoute>
          }
        />
        <Route
          path="notifications"
          element={
            <PermissionRoute permission="view_notifications">
              <NotificationsPage />
            </PermissionRoute>
          }
        />
      </Route>

      {/* First-login onboarding wizard — full-screen, no app chrome.
          AuthRoute pins new member/HR accounts here until they finish. */}
      <Route path="/start" element={<OnboardingWizard />} />
    </Route>

    {/* Public invite-link landing — validates the token and points at login */}
    <Route path="/onboarding/:token" element={<Onboarding />} />

    {/* Public accept-invite — new joiner sets their own password, no login */}
    <Route path="/accept-invite" element={<AcceptInvite />} />
  </>
);
